export class ReservationDish {
    dishName: string;
    dishId: number;
    count: number;
    unitPrice: number;
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/models/reservation-dish.ts